import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpAuctionHeadline', pkpAuctionHeadline);

    /**
     * Basically a template for the current headline section for the auction pages (list, bid etc.).
     *
     * @author flzemke.btc
     * @ngInject
     */
    function pkpAuctionHeadline(
        $window,
        DATES,
        auctionsOverviewService,
        activitiesService
    ) {
        return {
            restrict: 'E',
            scope: {
                runtime: '=',
                numberOfAuctions: '=?',
                phase: '=',
                type: '=',
                state: '=',
                suspended: '=',
                nextClose: '=?',
                nextOpen: '=?',
                auctionStart: '=?',
                networkPoint: '=',
                hideGrayBar: '=?',
                disableLink: '=?',
                hideRuntime: '=?',
                periodType: '=',
                isAuction: '=?',
                countdownDateTime: '=?',
                term: '@'
            },
            transclude: true,
            template: require('app/_directives/pkp-auction-headline.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.DATES = DATES;
            scope.uiIsLongTermAuction = !angular.isUndefined(scope.periodType)
                ? auctionsOverviewService.isLongTermAuction(
                      auctionsOverviewService.getPeriodTypeByValue(
                          scope.periodType
                      )
                  )
                : false;

            scope.PHASE = activitiesService.STATE;
            scope.goBack = goBack;
            scope.historyLength = $window.history.length;
            if (scope.hideGrayBar !== true) {
                scope.hideGrayBar = false;
            }

            if (scope.hideRuntime !== true) {
                scope.hideRuntime = false;
            }

            if (scope.isAuction !== false) {
                scope.isAuction = true;
            }

            if (scope.disableLink !== true) {
                scope.disableLink = false;
            }

            function goBack() {
                if (!scope.disableLink) {
                    $window.history.back();
                }
            }
        }
    }
})();
